import { defineComponent, h } from 'vue';

export const TableBoxHead = defineComponent({
  name: 'TableBoxHead',
  setup(props, context) {
    return function render() {
      return h('td', {
        class: 'inspection-report__table-header',
      },
      context.slots.default?.());
    };
  },
});
